import type { RiskLevel } from "@/api/intelligence";

const styles: Record<RiskLevel, string> = {
  HEALTHY: "bg-emerald-100 text-emerald-700 border-emerald-200",
  WATCH: "bg-amber-100 text-amber-700 border-amber-200",
  AT_RISK: "bg-orange-100 text-orange-700 border-orange-200",
  CRITICAL: "bg-red-100 text-red-700 border-red-200",
};

export function RiskBadge({ level }: { level: RiskLevel }) {
  return (
    <span
      className={`inline-flex rounded-full border px-3 py-1 text-xs font-semibold ${styles[level]}`}
    >
      {level.replace("_", " ")}
    </span>
  );
}